import { Flame, ScrollText, Soup, Sparkles } from "lucide-react";

const ICONS = { Flame, ScrollText, Soup, Sparkles };

const FEATURES = [
  {
    title: "Recipes from Andhra",
    body: "Heirloom recipes from coastal Andhra kitchens — passed down, never diluted.",
    icon: "ScrollText",
  },
  {
    title: "Hand-Picked Spices",
    body: "Guntur chillies, single-origin cardamom and stone-ground masalas.",
    icon: "Flame",
  },
  {
    title: "Slow-Cooked Dum",
    body: "Sealed in handi, cooked over low flame — every grain holds its own.",
    icon: "Soup",
  },
  {
    title: "Daily, Never Stored",
    body: "Cooked fresh in small batches every single day. No reheating, ever.",
    icon: "Sparkles",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="bg-cream-deep py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-5 reveal">
            <div className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
              Why us
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-cocoa mt-3 leading-[1.05]">
              We&rsquo;re picky on purpose.
            </h2>
          </div>
          <div className="lg:col-span-7 reveal">
            <p className="text-cocoa-soft text-base md:text-lg leading-relaxed">
              You can taste shortcuts. So we don&apos;t take any. Every step —
              sourcing, soaking, layering, sealing, finishing — is done by hand,
              in small batches, the same way it has been done for generations
              along the Krishna.
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row md:items-stretch md:divide-x divide-y md:divide-y-0 divide-[#C8A14B]/30 rounded-2xl border border-cream-deep bg-card-warm overflow-hidden">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <div
                key={f.title}
                data-testid={`why-us-feature-${i}`}
                className="reveal flex-1 p-8 md:p-10 group hover:bg-[#FAF3E7] transition-colors"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-full bg-[#FAF3E7] border border-[#C8A14B]/50 flex items-center justify-center text-gold group-hover:scale-110 transition-transform">
                  <Icon size={20} />
                </div>
                <h3 className="font-display text-xl text-cocoa mt-5">
                  {f.title}
                </h3>
                <p className="text-sm text-cocoa-soft mt-2 leading-relaxed">
                  {f.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
